import { render, staticRenderFns } from "./cardTypeInfo.vue?vue&type=template&id=ce490cda&"
import script from "./cardTypeInfo.vue?vue&type=script&lang=ts&"
export * from "./cardTypeInfo.vue?vue&type=script&lang=ts&"
import style0 from "./cardTypeInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports